import useUserQueryStore from "../context/UserStore";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import MultiTenantClusterGetDto from "../dtos/multiTenantClusterDto";
import APIClient from "../services/apiClient";

interface UpdateClusterContext {
  previousClusters: MultiTenantClusterGetDto[];
}

const useUpdateCluster = (onUpdate: (updatedData: MultiTenantClusterGetDto[]) => void) => {
  const queryClient = useQueryClient();
  const currentToken = useUserQueryStore((s) => s.userQuery.currentToken);
  const apiClient = new APIClient<MultiTenantClusterGetDto>("/MultiTenantCluster", currentToken!);

  return useMutation<MultiTenantClusterGetDto, Error, MultiTenantClusterGetDto, UpdateClusterContext>({
    mutationFn: apiClient.put,
    onMutate: (newCluster) => {
      const previousClusters = queryClient.getQueryData<MultiTenantClusterGetDto[]>(["clusters"]) || [];
      queryClient.setQueryData<MultiTenantClusterGetDto[]>(["clusters"], (clusters) =>
        clusters?.map((cluster) => (cluster.id === newCluster.id ? newCluster : cluster))
      );

      return { previousClusters };
    },
    onSuccess: (savedCluster, newCluster) => {
      queryClient.setQueryData<MultiTenantClusterGetDto[]>(["clusters"], (clusters) =>
        clusters?.map((cluster) => (cluster.id === newCluster.id ? newCluster : cluster))
      );
      const previousClusters = queryClient.getQueryData<MultiTenantClusterGetDto[]>(["clusters"]) || [];
      const updatedClusters = previousClusters.map((cluster) => (cluster.id === newCluster.id ? newCluster : cluster));

      onUpdate(updatedClusters);
    },
    onError: (error, newCluster, context) => {
      if (!context) return;

      queryClient.setQueryData<MultiTenantClusterGetDto[]>(["clusters"], context.previousClusters);
    },
  });
};

export default useUpdateCluster;
